<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="$router.currentRoute.path == '/researcher/newPostDoc'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <div class="d-flex justify-content-center mt-3"></div>
      <b-tabs pills vertical>
        <b-tab :title="'حمایت‌های پیشین از دوره‌'">
          <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <template v-slot:header>
              <h4 class="mb-0">حمایت‌های پیشین</h4>
            </template>
            <b-form-group>
              <div class="d-flex" dir="ltr">
                <label
                  for="switch_1"
                  :class="
                    initial.initialObligation
                      ? 'ml-3 mb-0 done'
                      : 'ml-3 mb-0 required'
                  "
                >
                  اینجانب تعهد می کنم با مطالعه و آگاهی از
                  <b-button
                    id="downLoad"
                    title="دانلود تعهدات"
                    variant="link"
                    href="/researcher/rules/postDoc/آئین نامه پسادکتری.pdf"
                  >
                    <b-tooltip
                      placement="bottomleft"
                      target="downLoad"
                      triggers="hover"
                      variant="info"
                      >دانلود شیوه‌نامه</b-tooltip
                    >شیوه‌نامه حمایت از دوره‌های پسادکتری ستاد توسعه زیست فناوری </b-button
                  >و طرح تقسیم کار ملی زیست ‌فناوری نسبت به ارسال درخواست در
                  سامانه اقدام می نمایم
                </label>
                <b-form-checkbox
                  id="switch_1"
                  v-model="initial.initialObligation"
                ></b-form-checkbox>
              </div>
            </b-form-group>
            <hr />
            <h3 class="text-primary mb-4">پژوهشگر گرامی</h3>

            <p>
              به ابزار حمایت از طرح‌های پژوهشی سامانه تقسیم کار ملی خوش آمدید.
              خواهشمندیم ابتدا به سوالات زیر پاسخ دهید:
            </p>
            <b-form-group
              label="عنوان دوره پسا دکتری"
              :class="initial.faSubject ? 'done' : 'required'"
            >
              <b-form-input trim v-model="initial.faSubject" required>
              </b-form-input>
            </b-form-group>
            <b-form-group
              label="آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده است؟"
              :class="initial.initialIsSupported !== null ? 'done' : 'required'"
            >
              <b-form-radio-group v-model="initial.initialIsSupported">
                <b-form-radio :value="true">بله</b-form-radio>
                <b-form-radio :value="false">خیر</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              label="حمایت ها:"
              v-if="initial.initialIsSupported"
              :class="initial.initialSupportedType ? 'done' : 'required'"
            >
              <b-form-select
                class="myselect2"
                id="first"
                v-model="initial.initialSupportedType"
                :options="options"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group
              label="عنوان حمایت دریافتی"
              v-if="
                initial.initialSupportedType == 'other' &&
                initial.initialIsSupported
              "
              :class="initial.otherSupport ? 'done' : 'required'"
            >
              <b-form-input trim type="text" v-model="initial.otherSupport">
              </b-form-input>
            </b-form-group>
            <b-form-group
              label="توضیحات حمایت دریافتی:"
              v-if="initial.initialIsSupported"
              :class="initial.description ? 'done' : 'required'"
            >
              <b-form-textarea trim rows="6" v-model="initial.description">
              </b-form-textarea>
            </b-form-group>
          </b-card>
        </b-tab>
        <b-tab disabled :title="'اطلاعات اصلی دوره'"></b-tab>
        <b-tab disabled :title="'اطلاعات پژوهشگر'"></b-tab>
        <b-tab disabled :title="'اطلاعات مسئول پسا‌دکتری'"></b-tab>
        <b-tab disabled :title="'مشخصات دوره'"></b-tab>
        <b-tab disabled :title="'اطلاعات تجاری‌سازی'"></b-tab>
        <b-tab disabled :title="'زمانبندی'"></b-tab>
        <b-tab disabled :title="'فایل های تکمیلی'"></b-tab>
        <b-tab disabled :title="'تعهدات'"></b-tab>
        <b-tab disabled :title="'مرور نهایی و ارسال'"></b-tab>
      </b-tabs>
      <div class="d-flex justify-content-center mt-3">
        <!-- NOTE (b-start) To begin the proposal registration process -->
        <b-button
          class="mx-1"
          variant="primary"
          @click="start()"
          :disabled="
            !initial.faSubject ||
            !initial.initialObligation ||
            initial.initialIsSupported === null ||
            (initial.initialIsSupported && !initial.initialSupportedType) ||
            (initial.initialIsSupported && !initial.description) ||
            (initial.initialSupportedType &&
              initial.initialSupportedType == 'other' &&
              !initial.otherSupport)
          "
          >آغاز فرایند</b-button
        >
      </div>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import GSTC from "vue-gantt-schedule-timeline-calendar";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time

export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    GSTC,
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
  },
  data() {
    return {
      initial: {
        initialIsSupported: null,
      },
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      isLoaded: true,
    };
  },

  methods: {
    start() {
      // NOTE (m-start) to save drafts in each step
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.isSaving = true;

      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/postDoc/new",
          {
            initialObligation: this.initial.initialObligation,
            initialIsSupported: this.initial.initialIsSupported,
            initialSupportedType: this.initial.initialSupportedType,
            initialOtherSupport: this.initial.otherSupport,
            initialSupportDescription: this.initial.description,
            faSubject: this.initial.faSubject,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;

          const title = (
            <div>
              <h5>!ثبت پیشنویس</h5>
              <span>
                پیشنویس ثبت شد. برای ثبت نهایی تکمیل کلیه اطلاعات و زدن دکمه
                ارسال الزامی است
              </span>
            </div>
          );
          this.toast(title, "info");
          router.push("/researcher/completePostDoc/" + res.data);
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
</style>
